import { Database } from 'lucide-react';
import { Badge } from '@reflex/ui/components/ui/badge';
import { IconSectionHeader } from '@/components/shared/IconSectionHeader';
import type { PluginTableSchema } from '@/lib/plugin-registry';
import { TableSchemaCard } from './TableSchemaCard';

export function PluginDatabaseSection({ tables }: { tables: PluginTableSchema[] }) {
  if (tables.length === 0) return null;

  return (
    <section data-testid="plugin-detail-section-database">
      <IconSectionHeader
        icon={Database}
        action={
          <Badge variant="secondary" className="text-3xs font-normal tabular-nums">
            {tables.length} table{tables.length !== 1 ? 's' : ''}
          </Badge>
        }
      >
        Database Schema
      </IconSectionHeader>
      <div className="space-y-2">
        {tables.map((table) => (
          <TableSchemaCard key={table.name} table={table} />
        ))}
      </div>
    </section>
  );
}
